import React from 'react'
import Icon from './Icon'

/*
const MdSort = props => (
  <Icon viewBox="0 0 40 40" {...props}>
    <g>
      <path d="m5 21.6v-3.2h20v3.2h-20z m0-11.6h30v3.4h-30v-3.4z m0 20v-3.4h10v3.4h-10z" />
    </g>
  </Icon>
)
*/

const MdSort = props => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g>
      <path
        d="M8.20710678,15 L15.7928932,15 L15.7928932,15 C16.0690356,15 16.2928932,14.7761424 16.2928932,14.5 C16.2928932,14.3673918 16.2402148,14.2402148 16.1464466,14.1464466 L12.3535534,10.3535534 L12.3535534,10.3535534 C12.1582912,10.1582912 11.8417088,10.1582912 11.6464466,10.3535534 L7.85355339,14.1464466 L7.85355339,14.1464466 C7.65829124,14.3417088 7.65829124,14.6582912 7.85355339,14.8535534 C7.94732158,14.9473216 8.07449854,15 8.20710678,15 Z"
        transform="matrix(1 0 0 -1 0 25)"
      />
    </g>
  </Icon>
)

export default MdSort



// WEBPACK FOOTER //
// ./icons/Sort.js